// ----------------------------------------------------------------------
const ROOTS = {
  DASHBOARD: "/",
};

// ----------------------------------------------------------------------

export const paths = {
  dashboard: {
    root: ROOTS.DASHBOARD,
    aboutUs: `/about-us`,
    commercialVehicleLoan: `/commercial-vehicle-loan`,
    customerGrievance: `/customer-grievance`,
    privacyPolicy: `/privacy-policy`,
    termsAndConditions: `/terms-and-conditions`,
    contactUs: `/contact-us`,
    applicationForm: `/contact-us/application-form`,
    documentSubmission: `/contact-us/document-submission`,
    requestCallBackForm: `/contact-us/request-call-back-form`,
    constructorEquipment: `/construction-equipment`,
    twoWheelerpage: `/two-wheeler`,
    carloan: `/car-loan`,
    housePurchase: `/house-purchase`,
    houseConstruction: `/house-construction`,
    evCarLoan: `/ev-car-loan`,
    evTruckLoan: `/ev-truck-loan`,
    ev3WheelerLoan: `/ev-3-wheeler-loan`,
    loanAgainestProperty: `/loan-against-property`,
    insurenceAMC: `/insurance-amc`,
    spareParts: `/spare-parts`,
    personalLoan: `/personal-loan`,
    otherBusinessLoan: `/other-business-loan`,
    usedBusinessLoan: `/used-business-loan`,
    usedTractorFinance: `/used-tractor-finance`,
    ourProduct: `/our-product`,
    ourProduct1: `/our-product-1`,
    emiCalculator: `/emi-calculator`,
    careers: `/careers`,
  },
};
